(function () {
    window.KocotApp = window.KocotApp || {};

    function run(name) {
        if (!window.KocotAnimations || typeof window.KocotAnimations[name] !== 'function') {
            return;
        }

        window.KocotAnimations[name]();
    }

    function scrollToTop() {
        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
            window.lenis.scrollTo(0);
            return;
        }

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    function initScrollToTopButton() {
        if (document.documentElement.dataset.scrollToTopInitialized === 'true') {
            return;
        }

        document.documentElement.dataset.scrollToTopInitialized = 'true';
        document.addEventListener('click', function (event) {
            var button = event.target && event.target.closest ? event.target.closest('.page-footer-content-scroll-btn') : null;

            if (!button) {
                return;
            }

            event.preventDefault();
            scrollToTop();
        });
    }

    function init() {
        run('initLenis');
        run('initImageOverlayAnimations');
        run('initImageParallaxAnimations');
        run('initMousemoveAnimations');
        run('initElementAnimations');
        run('initHeaderAnimations');
        run('initStaggerAnimations');
        run('initFormFileInputs');
        run('initGalleryRealization');
        run('initMaps');
        run('initRealizationGalleryPopup');
        initScrollToTopButton();
    }

    window.KocotApp.scrollToTop = scrollToTop;
    window.KocotApp.initPage = init;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(init);
                return;
            }

            init();
        });
    } else {
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(init);
        } else {
            init();
        }
    }
})();
